import { h } from "vue";

import IconAccessRestricted from "@/components/icons/IconAccessRestricted.vue";
import IconAccountManagement from "@/components/icons/IconAccountManagement.vue";
import IconAddLine from "@/components/icons/IconAddLine.vue";
import IconAddPhoto from "@/components/icons/IconAddPhoto.vue";
import IconAlert from "@/components/icons/IconAlert.vue";
import IconAllotment from "@/components/icons/IconAllotment.vue";
import IconAnalytics from "@/components/icons/IconAnalytics.vue";
import IconAppBarMobile from "@/components/icons/IconAppBarMobile.vue";
import IconArrowDoubleNext from "@/components/icons/IconArrowDoubleNext.vue";
import IconArrowDoublePrevious from "@/components/icons/IconArrowDoublePrevious.vue";
import IconArrowDown from "@/components/icons/IconArrowDown.vue";
import IconArrowDownRegister from "@/components/icons/IconArrowDownRegister.vue";
import IconArrowDropdown from "@/components/icons/IconArrowDropdown.vue";
import IconArrowGreen from "@/components/icons/IconArrowGreen.vue";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import IconArrowRed from "@/components/icons/IconArrowRed.vue";
import IconArrowRight from "@/components/icons/IconArrowRight.vue";
import IconArrowRightRegister from "@/components/icons/IconArrowRightRegister.vue";
import IconArrowRightUp from "@/components/icons/IconArrowRightUp.vue";
import IconArrowSingleNext from "@/components/icons/IconArrowSingleNext.vue";
import IconArrowSinglePrevious from "@/components/icons/IconArrowSinglePrevious.vue";
import IconArrowSort from "@/components/icons/IconArrowSort.vue";
import IconAttention from "@/components/icons/IconAttention.vue";
import IconBell from "@/components/icons/IconBell.vue";
import IconBellFilled from "@/components/icons/IconBellFilled.vue";
import IconBilling from "@/components/icons/IconBilling.vue";
import IconBirthdayEmpty from "@/components/icons/IconBirthdayEmpty.vue";
import IconBlock from "@/components/icons/IconBlock.vue";
import IconBookingSelect from "@/components/icons/IconBookingSelect.vue";
import IconBurgerBar from "@/components/icons/IconBurgerBar.vue";
import IconButtonAdd from "@/components/icons/IconButtonAdd.vue";
import IconButtonEdit from "@/components/icons/IconButtonEdit.vue";
import IconCalendarX from "@/components/icons/IconCalendarX.vue";
import IconCamera from "@/components/icons/IconCamera.vue";
import IconCalendar from "@/components/icons/IconCalendar.vue";
import IconChampion from "@/components/icons/IconChampion.vue";
import IconChannel from "@/components/icons/IconChannel.vue";
import IconChannelId from "@/components/icons/IconChannelId.vue";
import IconCheck from "@/components/icons/IconCheck.vue";
import IconCheckbox from "@/components/icons/IconCheckbox.vue";
import IconCheckVerify from "@/components/icons/IconCheckVerify.vue";
import IconCircleClose from "@/components/icons/IconCircleClose.vue";
import IconCircleInfo from "@/components/icons/IconCircleInfo.vue";
import IconCircleInfoPrimary from "@/components/icons/IconCircleInfoPrimary.vue";
import IconCircleInfoWarning from "@/components/icons/IconCircleInfoWarning.vue";
import IconCircleQuestion from "@/components/icons/IconCircleQuestion.vue";
import IconClockRotateLeft from "@/components/icons/IconClockRotateLeft.vue";
import IconClockRotateRight from "@/components/icons/IconClockRotateRight.vue";
import IconClockTime from "@/components/icons/IconClockTime.vue";
import IconCloseDialog from "@/components/icons/IconCloseDialog.vue";
import IconCoffeeShopping from "@/components/icons/IconCoffeeShopping.vue";
import IconConfirm from "@/components/icons/IconConfirm.vue";
import IconConfirmDanger from "@/components/icons/IconConfirmDanger.vue";
import IconConfirmModal from "@/components/icons/IconConfirmModal.vue";
import IconCopy from "@/components/icons/IconCopy.vue";
import IconCross from "@/components/icons/IconCross.vue";
import IconDashboard from "@/components/icons/IconDashboard.vue";
import IconDashboardBooking from "@/components/icons/IconDashboardBooking.vue";
import IconDashboardCalendar from "@/components/icons/IconDashboardCalendar.vue";
import IconDashboardCircleInfo from "@/components/icons/IconDashboardCircleInfo.vue";
import IconDashboardUser from "@/components/icons/IconDashboardUser.vue";
import IconDatePicker from "@/components/icons/IconDatePicker.vue";
import IconDatePickerLight from "@/components/icons/IconDatePickerLight.vue";
import IconDatePickerRed from "@/components/icons/IconDatePickerRed.vue";
import IconDeviceRotate from "@/components/icons/IconDeviceRotate.vue";
import IconDot from "@/components/icons/IconDot.vue";
import IconDropDown from "@/components/icons/IconDropDown.vue";
import IconDuplicate from "@/components/icons/IconDuplicate.vue";
import IconEditPhoto from "@/components/icons/IconEditPhoto.vue";
import IconEllipseYellow from "@/components/icons/IconEllipseYellow.vue";
import IconExport from "@/components/icons/IconExport.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEyeHide from "@/components/icons/IconEyeHide.vue";
import IconFastDelivery from "@/components/icons/IconFastDelivery.vue";
import IconFilter from "@/components/icons/IconFilter.vue";
import IconFlagSg from "@/components/icons/IconFlagSg.vue";
import IconFlagMy from "@/components/icons/IconFlagMy.vue";
import IconFlagTha from "@/components/icons/IconFlagTha.vue";
import IconFloppyDisk from "@/components/icons/IconFloppyDisk.vue";
import IconGearConfig from "@/components/icons/IconGearConfig.vue";
import IconGlobal from "@/components/icons/IconGlobal.vue";
import IconHamburger from "@/components/icons/IconHamburger.vue";
import IconHandleDot from "@/components/icons/IconHandleDot.vue";
import IconHelp from "@/components/icons/IconHelp.vue";
import IconHelpEmail from "@/components/icons/IconHelpEmail.vue";
import IconImagePreview from "@/components/icons/IconImagePreview.vue";
import IconImport from "@/components/icons/IconImport.vue";
import IconLanguageCn from "@/components/icons/IconLanguageCn.vue";
import IconLanguageEng from "@/components/icons/IconLanguageEng.vue";
import IconLanguageMys from "@/components/icons/IconLanguageMys.vue";
import IconLanguageTha from "@/components/icons/IconLanguageTha.vue";
import IconLineArrow from "@/components/icons/IconLineArrow.vue";
import IconListDot from "@/components/icons/IconListDot.vue";
import IconLogoutFilled from "@/components/icons/IconLogoutFilled.vue";
import IconMail from "@/components/icons/IconMail.vue";
import IconMarkComplete from "@/components/icons/IconMarkComplete.vue";
import IconMarketing from "@/components/icons/IconMarketing.vue";
import IconMarkSuccess from "@/components/icons/IconMarkSuccess.vue";
import IconMedia from "@/components/icons/IconMedia.vue";
import IconMenu from "@/components/icons/IconMenu.vue";
import IconMenuItems from "@/components/icons/IconMenuItems.vue";
import IconMenuList from "@/components/icons/IconMenuList.vue";
import IconMessage from "@/components/icons/IconMessage.vue";
import IconMessagePlus from "@/components/icons/IconMessagePlus.vue";
import IconMinus from "@/components/icons/IconMinus.vue";
import IconMoney from "@/components/icons/IconMoney.vue";
import IconMoneyRed from "@/components/icons/IconMoneyRed.vue";
import IconNewStore from "@/components/icons/IconNewStore.vue";
import IconNoResult from "@/components/icons/IconNoResult.vue";
import IconNote from "@/components/icons/IconNote.vue";
import IconNoteColor from "@/components/icons/IconNoteColor.vue";
import IconNotifyReview from "@/components/icons/IconNotifyReview.vue";
import IconNotiPackage from "@/components/icons/IconNotiPackage.vue";
import IconOccasion from "@/components/icons/IconOccasion.vue";
import IconPackage from "@/components/icons/IconPackage.vue";
import IconPencil from "@/components/icons/IconPencil.vue";
import IconPencilSquare from "@/components/icons/IconPencilSquare.vue";
import IconPerson from "@/components/icons/IconPerson.vue";
import IconPhone from "@/components/icons/IconPhone.vue";
import IconPlace from "@/components/icons/IconPlace.vue";
import IconPlus from "@/components/icons/IconPlus.vue";
import IconPlusCircle from "@/components/icons/IconPlusCircle.vue";
import IconPriceTag from "@/components/icons/IconPriceTag.vue";
import IconPriceTagGradient from "@/components/icons/IconPriceTagGradient.vue";
import IconQrCode from "@/components/icons/IconQrCode.vue";
import IconRatingReview from "@/components/icons/IconRatingReview.vue";
import IconRatingReviewFill from "@/components/icons/IconRatingReviewFill.vue";
import IconReceiptLong from "@/components/icons/IconReceiptLong.vue";
import IconRegisterDropDown from "@/components/icons/IconRegisterDropDown.vue";
import IconRemark from "@/components/icons/IconRemark.vue";
import IconRemarkGrey from "@/components/icons/IconRemarkGrey.vue";
import IconReport from "@/components/icons/IconReport.vue";
import IconRestaurantCleanup from "@/components/icons/IconRestaurantCleanup.vue";
import IconRestaurantCutlery from "@/components/icons/IconRestaurantCutlery.vue";
import IconRestaurantDish from "@/components/icons/IconRestaurantDish.vue";
import IconRestaurantDistance from "@/components/icons/IconRestaurantDistance.vue";
import IconRestaurantFurniture from "@/components/icons/IconRestaurantFurniture.vue";
import IconRestaurantPrevent from "@/components/icons/IconRestaurantPrevent.vue";
import IconRestaurantPrice from "@/components/icons/IconRestaurantPrice.vue";
import IconRestaurantRating from "@/components/icons/IconRestaurantRating.vue";
import IconSave from "@/components/icons/IconSave.vue";
import IconSearch from "@/components/icons/IconSearch.vue";
import IconSearchOff from "@/components/icons/IconSearchOff.vue";
import IconSessionExpired from "@/components/icons/IconSessionExpired.vue";
import IconSidebarAllotment from "@/components/icons/IconSidebarAllotment.vue";
import IconSidebarBooking from "@/components/icons/IconSidebarBooking.vue";
import IconSidebarMarketing from "@/components/icons/IconSidebarMarketing.vue";
import IconSidebarMenu from "@/components/icons/IconSidebarMenu.vue";
import IconSidebarPackage from "@/components/icons/IconSidebarPackage.vue";
import IconSidebarReview from "@/components/icons/IconSidebarReview.vue";
import IconSidebarVoucher from "@/components/icons/IconSidebarVoucher.vue";
import IconSmiley from "@/components/icons/IconSmiley.vue";
import IconSortActiveAsc from "@/components/icons/IconSortActiveAsc.vue";
import IconSortActiveDesc from "@/components/icons/IconSortActiveDesc.vue";
import IconSortUpDown from "@/components/icons/IconSortUpDown.vue";
import IconStar from "@/components/icons/IconStar.vue";
import IconStarBlack from "@/components/icons/IconStarBlack.vue";
import IconStartYellow from "@/components/icons/IconStartYellow.vue";
import IconStore from "@/components/icons/IconStore.vue";
import IconSuccess from "@/components/icons/IconSuccess.vue";
import IconSuccessRegister from "@/components/icons/IconSuccessRegister.vue";
import IconTicket from "@/components/icons/IconTicket.vue";
import IconTier from "@/components/icons/IconTier.vue";
import IconToastAlert from "@/components/icons/IconToastAlert.vue";
import IconToggle from "@/components/icons/IconToggle.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import IconTrashLight from "@/components/icons/IconTrashLight.vue";
import IconTrendingDown from "@/components/icons/IconTrendingDown.vue";
import IconTrendingUp from "@/components/icons/IconTrendingUp.vue";
import IconUndo from "@/components/icons/IconUndo.vue";
import IconUser from "@/components/icons/IconUser.vue";
import IconUserCircle from "@/components/icons/IconUserCircle.vue";
import IconUserColor from "@/components/icons/IconUserColor.vue";
import IconUserConfig from "@/components/icons/IconUserConfig.vue";
import IconUserPending from "@/components/icons/IconUserPending.vue";
import IconValidateError from "@/components/icons/IconValidateError.vue";
import IconVoucher from "@/components/icons/IconVoucher.vue";
import IconWarning from "@/components/icons/IconWarning.vue";
import IconWarningChip from "@/components/icons/IconWarningChip.vue";
import IconWarningModal from "@/components/icons/IconWarningModal.vue";
import IconWatch from "@/components/icons/IconWatch.vue";
import IconWhatsApp from "@/components/icons/IconWhatsApp.vue";

const aliases = {
  iconAccessRestricted: IconAccessRestricted,
  iconAccountManagement: IconAccountManagement,
  iconAddLine: IconAddLine,
  iconAddPhoto: IconAddPhoto,
  iconAlert: IconAlert,
  iconAllotment: IconAllotment,
  iconAnalytics: IconAnalytics,
  iconAppBarMobile: IconAppBarMobile,
  iconArrowDoubleNext: IconArrowDoubleNext,
  iconArrowDoublePrevious: IconArrowDoublePrevious,
  iconArrowDown: IconArrowDown,
  iconArrowDownRegister: IconArrowDownRegister,
  iconArrowDropdown: IconArrowDropdown,
  iconArrowGreen: IconArrowGreen,
  iconArrowLeft: IconArrowLeft,
  iconArrowRed: IconArrowRed,
  iconArrowRight: IconArrowRight,
  iconArrowRightRegister: IconArrowRightRegister,
  iconArrowRightUp: IconArrowRightUp,
  iconArrowSingleNext: IconArrowSingleNext,
  iconArrowSinglePrevious: IconArrowSinglePrevious,
  iconArrowSort: IconArrowSort,
  iconAttention: IconAttention,
  iconBell: IconBell,
  iconBellFilled: IconBellFilled,
  iconBilling: IconBilling,
  iconBirthdayEmpty: IconBirthdayEmpty,
  iconBlock: IconBlock,
  iconBookingSelect: IconBookingSelect,
  iconBurgerBar: IconBurgerBar,
  iconButtonAdd: IconButtonAdd,
  iconButtonEdit: IconButtonEdit,
  iconCalendarX: IconCalendarX,
  iconCamera: IconCamera,
  iconCalendar: IconCalendar,
  iconChampion: IconChampion,
  iconChannel: IconChannel,
  iconChannelId: IconChannelId,
  iconCheck: IconCheck,
  iconCheckbox: IconCheckbox,
  iconCheckVerify: IconCheckVerify,
  iconCircleClose: IconCircleClose,
  iconCircleInfo: IconCircleInfo,
  iconCircleInfoPrimary: IconCircleInfoPrimary,
  iconCircleInfoWarning: IconCircleInfoWarning,
  iconCircleQuestion: IconCircleQuestion,
  iconClockRotateLeft: IconClockRotateLeft,
  iconClockRotateRight: IconClockRotateRight,
  iconClockTime: IconClockTime,
  iconCloseDialog: IconCloseDialog,
  iconCoffeeShopping: IconCoffeeShopping,
  iconConfirm: IconConfirm,
  iconConfirmDanger: IconConfirmDanger,
  iconConfirmModal: IconConfirmModal,
  iconCopy: IconCopy,
  iconCross: IconCross,
  iconDashboard: IconDashboard,
  iconDashboardBooking: IconDashboardBooking,
  iconDashboardCalendar: IconDashboardCalendar,
  iconDashboardCircleInfo: IconDashboardCircleInfo,
  iconDashboardUser: IconDashboardUser,
  iconDatePicker: IconDatePicker,
  iconDatePickerLight: IconDatePickerLight,
  iconDatePickerRed: IconDatePickerRed,
  iconDeviceRotate: IconDeviceRotate,
  iconDot: IconDot,
  iconDropDown: IconDropDown,
  iconDuplicate: IconDuplicate,
  iconEditPhoto: IconEditPhoto,
  iconEllipseYellow: IconEllipseYellow,
  iconExport: IconExport,
  iconEye: IconEye,
  iconEyeHide: IconEyeHide,
  iconFastDelivery: IconFastDelivery,
  iconFilter: IconFilter,
  iconFlagSg: IconFlagSg,
  iconFlagMy: IconFlagMy,
  iconFlagTha: IconFlagTha,
  iconFloppyDisk: IconFloppyDisk,
  iconGearConfig: IconGearConfig,
  iconGlobal: IconGlobal,
  iconHamburger: IconHamburger,
  iconHandleDot: IconHandleDot,
  iconHelp: IconHelp,
  iconHelpEmail: IconHelpEmail,
  iconImagePreview: IconImagePreview,
  iconImport: IconImport,
  iconLanguageCn: IconLanguageCn,
  iconLanguageEng: IconLanguageEng,
  iconLanguageMys: IconLanguageMys,
  iconLanguageTha: IconLanguageTha,
  iconLineArrow: IconLineArrow,
  iconListDot: IconListDot,
  iconLogoutFilled: IconLogoutFilled,
  iconMail: IconMail,
  iconResendInvite: IconMail,
  iconMarkComplete: IconMarkComplete,
  iconMarketing: IconMarketing,
  iconMarkSuccess: IconMarkSuccess,
  iconMedia: IconMedia,
  iconMenu: IconMenu,
  iconMenuItems: IconMenuItems,
  iconMenuList: IconMenuList,
  iconMessage: IconMessage,
  iconMessagePlus: IconMessagePlus,
  iconMinus: IconMinus,
  iconMoney: IconMoney,
  iconMoneyRed: IconMoneyRed,
  iconNewStore: IconNewStore,
  iconNoResult: IconNoResult,
  iconNote: IconNote,
  iconNoteColor: IconNoteColor,
  iconNotifyReview: IconNotifyReview,
  iconNotiPackage: IconNotiPackage,
  iconOccasion: IconOccasion,
  iconPackage: IconPackage,
  iconPencil: IconPencil,
  iconPencilSquare: IconPencilSquare,
  iconPerson: IconPerson,
  iconPhone: IconPhone,
  iconPlace: IconPlace,
  iconPlus: IconPlus,
  iconPlusCircle: IconPlusCircle,
  iconPriceTag: IconPriceTag,
  iconPriceTagGradient: IconPriceTagGradient,
  iconQrCode: IconQrCode,
  iconRatingReview: IconRatingReview,
  iconRatingReviewFill: IconRatingReviewFill,
  iconReceiptLong: IconReceiptLong,
  iconRegisterDropDown: IconRegisterDropDown,
  iconRemark: IconRemark,
  iconRemarkGrey: IconRemarkGrey,
  iconReport: IconReport,
  iconRestaurantCleanup: IconRestaurantCleanup,
  iconRestaurantCutlery: IconRestaurantCutlery,
  iconRestaurantDish: IconRestaurantDish,
  iconRestaurantDistance: IconRestaurantDistance,
  iconRestaurantFurniture: IconRestaurantFurniture,
  iconRestaurantPrevent: IconRestaurantPrevent,
  iconRestaurantPrice: IconRestaurantPrice,
  iconRestaurantRating: IconRestaurantRating,
  iconSave: IconSave,
  iconSearch: IconSearch,
  iconSearchOff: IconSearchOff,
  iconSessionExpired: IconSessionExpired,
  iconSidebarAllotment: IconSidebarAllotment,
  iconSidebarBooking: IconSidebarBooking,
  iconSidebarMarketing: IconSidebarMarketing,
  iconSidebarMenu: IconSidebarMenu,
  iconSidebarPackage: IconSidebarPackage,
  iconSidebarReview: IconSidebarReview,
  iconSidebarVoucher: IconSidebarVoucher,
  iconSmiley: IconSmiley,
  iconSortActiveAsc: IconSortActiveAsc,
  iconSortActiveDesc: IconSortActiveDesc,
  iconSortUpDown: IconSortUpDown,
  iconStar: IconStar,
  iconStarBlack: IconStarBlack,
  iconStartYellow: IconStartYellow,
  iconStore: IconStore,
  iconSuccess: IconSuccess,
  iconSuccessRegister: IconSuccessRegister,
  iconTicket: IconTicket,
  iconTier: IconTier,
  iconToastAlert: IconToastAlert,
  iconToggle: IconToggle,
  iconTrash: IconTrash,
  iconTrashLight: IconTrashLight,
  iconTrendingDown: IconTrendingDown,
  iconTrendingUp: IconTrendingUp,
  iconUndo: IconUndo,
  iconUser: IconUser,
  iconUserCircle: IconUserCircle,
  iconUserColor: IconUserColor,
  iconUserConfig: IconUserConfig,
  iconUserPending: IconUserPending,
  iconValidateError: IconValidateError,
  iconVoucher: IconVoucher,
  iconWarning: IconWarning,
  iconWarningChip: IconWarningChip,
  iconWarningModal: IconWarningModal,
  iconWatch: IconWatch,
  iconWhatsApp: IconWhatsApp,
};

const custom = {
  // component: (props) => h(props.tag, [h(myIconPack, { class: "v-icon__svg" })]),
  component: (props) => h(props.component),
};

export { aliases, custom };
